import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messagePipe'
})
export class MessagePipePipe implements PipeTransform {

  transform(value: any, args?: any): string {
    let message = Object.values<string>(value);
    return message[0];
  }

}
